import React from 'react';
import Posts from './Posts';
import './App.css';

function App() {
  return (
    <div className="App">
      <Posts/>
    </div>
  );
}

export default App;
